<template>
  <div>
    <div>
      <!-- 基本信息 -->
      <div class="title">{{$t('accept.jbxx')}}</div>
      <slot v-if="Station.ischz" name="textHeader"></slot>
      <el-form v-else ref="form" :model="form" label-width="80px" :inline="true">
        <!-- 车站 -->
        <el-form-item :label="$t('cargoTracking.cz')"> {{ form.czmc }} </el-form-item>
        <!-- 所属局 -->
        <el-form-item :label="$t('roleManagement.ssj')"> {{ form.ljjc }} </el-form-item>
        <!-- 货运站 -->
        <el-form-item :label="$t('zcxz.hyz')"> {{ form.ishyz == 0 ? $t('myMessage.yes') : $t('myMessage.no') }}</el-form-item>
      </el-form>

    </div>
    <div>
      <!-- 起重能力 -->
      <div class="title">{{$t('stationinfo.qznl')}}</div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="djhwqznl" :label="$t('zcxz.zdqznl')" width="180">
        </el-table-column>
        <el-table-column prop="ccqznl" :label="$t('zcxz.ccqznl')" width="180">
        </el-table-column>
        <el-table-column prop="jzxqznl20" :label="$t('zcxz.jzxqznl20')">
        </el-table-column>
        <el-table-column prop="jzxqznl40" :label="$t('zcxz.jzxqznl40')">
        </el-table-column>
      </el-table>
    </div>
    <div>
      <!-- 办理范围 -->
      <div class="title">{{$t('zcxz.blfw')}}</div>
      <!-- 整车办理范围 -->
      <div class="title2">{{$t('zcxz.zcblfw')}}</div>
      <el-table :data="tableData" style="width: 100%" border>
        <!-- 办理发送品类 -->
        <el-table-column prop="fsplmc" :label="$t('zcxz.blfspl')">
        </el-table-column>
        <!-- 办理到达品类 -->
        <el-table-column prop="ddplmc" :label="$t('zcxz.blddpl')">
        </el-table-column>
        <!-- 不办理发送品类 -->
        <el-table-column prop="nfsplmc" :label="$t('zcxz.bblfspl')">
        </el-table-column>
        <!-- 不办理到达品类 -->
        <el-table-column prop="nddplmc" :label="$t('zcxz.bblddpl')">
        </el-table-column>
      </el-table>
      <!-- 办理货物特征 -->
      <div class="title2">{{$t('zcxz.blhwtz')}}</div>
      <el-table :data="tableData" style="width: 100%" border>
        <!-- 超重 -->
        <el-table-column prop="sfcz" :label="$t('zcxz.cz')">
          <template slot-scope="scope">
            {{ scope.row.sfcz == 0 ? $t('myMessage.yes') : $t('myMessage.no') }}
          </template>
        </el-table-column>
        <!-- 超限 -->
        <el-table-column prop="sfcx" :label="$t('zcxz.cx')">
          <template slot-scope="scope">
            {{ scope.row.sfcx == 0 ? $t('myMessage.yes') : $t('myMessage.no') }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 集装箱办理范围 -->
      <div class="title2">{{$t('zcxz.jzxblfw')}}</div>
      <el-table :data="tableData" style="width: 100%" border>
        <!-- 20英尺箱 -->
        <el-table-column prop="bzx20" :label="$t('zcxz.ycx20')" width="180">
          <template slot-scope="scope">
            {{ filterText(scope.row.bzx20) }}
          </template>
        </el-table-column>
        <!-- 40(45)英尺箱 -->
        <el-table-column prop="bzx40" :label="$t('zcxz.ycx40')" label="" width="180">
          <template slot-scope="scope">
            {{ filterText(scope.row.bzx40) }}
          </template>
        </el-table-column>
        <!-- 20英尺干散箱 -->
        <el-table-column prop="gsx20" :label="$t('zcxz.gsx20')">
          <template slot-scope="scope">
            {{ filterText(scope.row.gsx20) }}
          </template>
        </el-table-column>
        <!-- 20英尺水泥罐式箱 -->
        <el-table-column prop="sng20" :label="$t('zcxz.sng20')">
          <template slot-scope="scope">
            {{ filterText(scope.row.sng20) }}
          </template>
        </el-table-column>
        <!-- 20英尺液体罐式箱 -->
        <el-table-column prop="ytg20" :label="$t('zcxz.ytg20')">
          <template slot-scope="scope">
            {{ filterText(scope.row.ytg20) }}
          </template>
        </el-table-column>
        <!-- 20英尺石油沥青罐式箱 -->
        <el-table-column prop="lqg20" :label="$t('zcxz.lqg20')">
          <template slot-scope="scope">
            {{ filterText(scope.row.lqg20) }}
          </template>
        </el-table-column>
        <!-- 20英尺台架式卷钢箱 -->
        <el-table-column prop="jgx20" :label="$t('zcxz.jgx20')">
          <template slot-scope="scope">
            {{ filterText(scope.row.jgx20) }}
          </template>
        </el-table-column>
        <!-- 20英尺35t敞顶箱 -->
        <el-table-column prop="tcd35" :label="$t('zcxz.tcd35')">
          <template slot-scope="scope">
            {{ filterText(scope.row.tcd35) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <!-- 危险品办理范围 -->
      <div class="title">{{$t('zcxz.wxpblfw')}}</div>
      <el-table :data="tableData[0].wxpList" style="width: 100%" border>
        <el-table-column prop="lx" :label="$t('myMessage.lx')" width="180">
           <template slot-scope="scope">
            <!-- 整车 集装箱 -->
            {{ scope.row.lx == 1 ? $t('dayDemandApply.zc') : $t('dayDemandApply.jzx') }}
          </template>
        </el-table-column>
        <!-- 发送品命 -->
        <el-table-column prop="fsPmhz" :label="$t('zcxz.fspm')" width="180">
        </el-table-column>
        <!-- 到达品名 -->
        <el-table-column prop="ddPmhz" :label="$t('zcxz.ddpm')"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { queryblxzByCzApi } from "@/api/blxz/index.js";
export default {
  name: "blxzDla",
  props: ["Station"], //type == true 中国段 到站  ==false 老挝段 发站
  data() {
    return {
      form: {},
      tableData: [{wxpList:[]}],
    };
  },
  mounted() {
  },
  methods: {
    getxq() {
      // Station.cztmis
      if (this.Station.type) {
      } else {
        queryblxzByCzApi({ cztmis: this.Station.cztmis }).then((res) => {
          console.log(res);
          this.form = res.data;
          this.tableData=[{ ...this.form }];
        });
      }
    },
    filterText(value) {
      if (value == 0) {
        return "无";
      }
      if (value == 1) {
        return "发";
      }
      if (value == 2) {
        return "到";
      }
      if (value == 3) {
        return "发到";
      }
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-table__body-wrapper {
  min-height: 48px;
}
.title {
  font-weight: bold;
  font-size: 16px;
  margin: 10px 0px;
}
.title2 {
  font-size: 16px;
  margin: 10px;
}
</style>